import React, {Component} from 'react'
import { Link } from 'react-router-dom'
// import './header.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import SubPrincipaisConsultores from './sub_principais_consultores.js';

class ListaCategoriaDropdown extends Component {

    constructor(props){
        super(props);
        this.state = {
            categoria: [],
            //Filtro para pesquisa
            selectedCategoria: ''

        }
    }

    componentDidMount(){
        this.setState({categoria: this.props.categoria});
    }


    onSelectCategoria = (event) => {
        this.setState({selectedCategoria : event.target.name})
        console.log(`categoria selecionada:  ${event.target.name}`)
    }

    render(){

        return(
        
            this.props.categoria.map((item, index)=>{
                return(
                     
                    <li key = {item.nome}><Link to = {'/usuario/profissionais'}>{item.nome}</Link><FontAwesomeIcon icon={faAngleRight} size='lg'/>
                    <ul id="submenu ">
                        <div className= "row">
                            <div className="col-md-4">    

                            <h4 className = "headerSub" >{item.nome}</h4>
                                <hr className="customhr"/>
                                {
                                    item.sub.map((subcategoria) => {
                                        return(
                                                <li  key = {subcategoria.nome}>
                                                    <Link className="sub-link" 
                                                        name = {subcategoria.nome} 
                                                        onClick = {this.onSelectCategoria} 
                                                        to = {'/usuario/profissionais'}
                                                    >
                                                        {subcategoria.nome}
                                                    </Link>

                                                </li>

                                        )

                                    })

                                    
                                }

                            </div>

                                <div className = "col-md-8">
                                    <SubPrincipaisConsultores/>

                                </div>
                            </div>
                        


                    </ul>

                </li>

        

               )
           
        
        })

               

    )


    

        
    }
    


}



export default ListaCategoriaDropdown